<div class="container">
	<div class="d-flex justify-content-center h-100">
		<div class="card">
            <div class="card-header">
				<h3>Sign In</h3>
			</div>
			<div class="card-body">
                <div class="subtitle" *ngIf="authService.user$ | async as user">
                    <p class="text-center">We have sent a confirmation email to <strong>{{user.email}}</strong>.</p>
                    <p class="text-center">Please check your email and click on the link to verfiy your email address.</p>
                  </div>
                  <button type="button" class="btn btn-block login_btn" (click)="authService.sendVerificationMail()">
                    <fa-icon [icon]="faRedoAlt"></fa-icon>
                    Resend Verification Email
                  </button>
			</div>
			<div class="card-footer">
				<div class="d-flex justify-content-center links">
					<span>Go back to?<a routerLink="/login"> Sign in</a></span>
				</div>
			</div>
		</div>
	</div>
</div>

